import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {plainToClass} from 'class-transformer';
import {environment} from '../../../environments/environment';
import {OwnerInvitationApiModel} from '../models/owner-invitation.api-model';

@Injectable({
  providedIn: 'root'
})
export class OwnerInvitationRestService {
  private readonly resource: string = '/owner_invitations';

  constructor(private http: HttpClient) {}

  public deny(invitation: OwnerInvitationApiModel): Observable<OwnerInvitationApiModel> {
    const url = invitation['@id']
      ? `${environment.apiUrl}${invitation['@id']}/deny`
      : `${environment.apiUrl}${this.resource}/${invitation.id}/deny`;
    return this.http.post<OwnerInvitationApiModel>(url, {})
      .pipe(map((result: OwnerInvitationApiModel) => plainToClass(OwnerInvitationApiModel, result)));
  }
}
